import moment from 'moment'

export function formatDateToTimeMonth(date) {
	return `${moment(date).format('hh:mm A')}, ${moment(date).format('MMM DD')}`
}
